<template>
  <div class="card">
    <div class="card-header">
      <div class="title">
        Selected
        <a :title="description">
          <em>{{ title }}</em>
        </a>
      </div>
      <button
        title="Click to select all entities of this type"
        @click="$emit('select-all')"
      >
        Select all
      </button>
      <button
        v-if="entityIds.length > 0"
        type="button"
        title="Click to remove all entities from the selection"
        @click="$emit('close-all')"
      >
        Clear all
      </button>
      <div class="custom-control custom-switch float-right">
        <input
          :id="title + 'Color'"
          type="radio"
          name="colored-selection"
          class="custom-control-input"
          @click="$emit('colored-change', $event.target.checked)"
        />
        <label
          class="custom-control-label"
          :for="title + 'Color'"
          title="Activate coloring for this selection category"
        >
          <font-awesome-icon icon="palette" />
        </label>
      </div>
    </div>
    <div class="card-body">
      <span v-if="entityIds.length === 0" v-html="adviceText"></span>
      <!-- TODO: refactor special case for picking the color of a node -->
      <SelectedEntity
        v-for="(id, index) in entityIds"
        :id="id"
        :key="id"
        :title="entityNames[index]"
        :color="
          colored
            ? $colorService.getColorById(title === 'nodes' ? id : index)
            : 'silver'
        "
        @close="$emit('close-entity', id)"
      ></SelectedEntity>
    </div>
  </div>
</template>

<script>
import SelectedEntity from "./SelectedEntity.vue";

export default {
  components: {
    SelectedEntity
  },
  props: {
    title: { type: String, required: true },
    entityIds: { type: Array, required: true },
    entityNames: { type: Array, required: true },
    colored: { type: Boolean, required: true },
    adviceText: { type: String, required: true },
    description: { type: String, required: true }
  },
  event: ["close-entity", "close-all", "colored-changed", "select-all"]
};
</script>

<style lang="scss">
.card-header .title {
  float: left;
  margin-right: 20px;
}
.card-header .custom-control {
  margin-top: 5px;
  cursor: pointer;
}
.card-header button {
  margin-top: 4px;
}
.card .card-header input {
  cursor: pointer;
}
.card-header label {
  cursor: pointer;
}
.card-body {
  height: 85px;
}
</style>
